export default __webpack_public_path__ + "static/media/communication.93c71dad.jpg";